import React, { useState } from "react";
import { trackOrder } from "../api/trackOrderService";
import "./TrackOrder.css";

const TrackOrder = () => {
  const [orderId, setOrderId] = useState("");
  const [phone, setPhone] = useState("");

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleTrackOrder = async (event) => {
    event.preventDefault();

    setError("");
    setOrder(null);

    if (!orderId.trim() || !phone.trim()) {
      setError("Please enter both Order ID and phone number.");
      return;
    }

    try {
      setLoading(true);

      const data = await trackOrder(orderId.trim(), phone.trim());

      setOrder(data);
    } catch (error) {
      console.error("Track order error:", error);

      if (error.response && error.response.data) {
        setError(
          typeof error.response.data === "string"
            ? error.response.data
            : "Unable to find your order.",
        );
      } else {
        setError("Unable to connect to the server. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const getStatusClass = (status) => {
    if (!status) {
      return "";
    }

    return status.toLowerCase().replace("_", "-");
  };

  const statuses = ["PLACED", "CONFIRMED", "PACKED", "SHIPPED", "DELIVERED"];

  const getCurrentStatusIndex = () => {
    if (!order) {
      return -1;
    }

    return statuses.indexOf(order.status);
  };

  return (
    <main className="track-order-page">
      <section className="track-order-container">
        <div className="track-order-heading">
          <p className="track-eyebrow">STAR GOLD</p>

          <h1>Track Your Order</h1>

          <p>Enter your Order ID and phone number to view your order status.</p>
        </div>

        <form className="track-order-form" onSubmit={handleTrackOrder}>
          <div className="track-input-group">
            <label>Order ID</label>

            <input
              type="number"
              placeholder="Example: 101"
              value={orderId}
              onChange={(event) => setOrderId(event.target.value)}
            />
          </div>

          <div className="track-input-group">
            <label>Phone Number</label>

            <input
              type="tel"
              placeholder="Enter your phone number"
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
            />
          </div>

          {error && <div className="track-error">{error}</div>}

          <button type="submit" className="track-button" disabled={loading}>
            {loading ? "Checking..." : "Track Order"}
          </button>
        </form>

        {order && (
          <section className="order-result">
            <div className="order-result-header">
              <div>
                <p>ORDER</p>
                <h2>#{order.orderId}</h2>
              </div>

              <div
                className={`order-status-badge ${getStatusClass(order.status)}`}
              >
                {order.status}
              </div>
            </div>

            <div className="order-customer">
              <p>
                Hello, <strong>{order.customerName}</strong>
              </p>

              {order.orderDate && (
                <p>Order Date: {new Date(order.orderDate).toLocaleString()}</p>
              )}
            </div>

            {order.status === "CANCELLED" ? (
              <div className="cancelled-order">
                <h3>Order Cancelled</h3>
                <p>This order has been cancelled.</p>
              </div>
            ) : (
              <div className="order-timeline">
                {statuses.map((status, index) => {
                  const currentIndex = getCurrentStatusIndex();

                  const completed = index <= currentIndex;

                  return (
                    <div
                      className={`timeline-step ${
                        completed ? "completed" : ""
                      }`}
                      key={status}
                    >
                      <div className="timeline-dot">{completed ? "✓" : ""}</div>

                      <div className="timeline-content">
                        <h3>
                          {status === "PLACED"
                            ? "Order Placed"
                            : status === "CONFIRMED"
                              ? "Confirmed"
                              : status === "PACKED"
                                ? "Packed"
                                : status === "SHIPPED"
                                  ? "Shipped"
                                  : "Delivered"}
                        </h3>

                        <p>
                          {status === "PLACED"
                            ? "Your order has been received."
                            : status === "CONFIRMED"
                              ? "Your order has been confirmed."
                              : status === "PACKED"
                                ? "Your jewellery is being prepared."
                                : status === "SHIPPED"
                                  ? "Your order is on its way."
                                  : "Your order has been delivered."}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            <div className="tracked-products">
              <h3>Order Items</h3>

              {order.items &&
                order.items.map((item, index) => (
                  <div className="tracked-product" key={index}>
                    <div>
                      <strong>{item.productName}</strong>

                      <span>Quantity: {item.quantity}</span>
                    </div>

                    <strong>
                      ₹{Number(item.price).toLocaleString("en-IN")}
                    </strong>
                  </div>
                ))}
            </div>

            <div className="tracked-total">
              <span>Total</span>

              <strong>
                ₹{Number(order.totalAmount).toLocaleString("en-IN")}
              </strong>
            </div>
          </section>
        )}
      </section>
    </main>
  );
};

export default TrackOrder;
